//@ts-ignore
import { tw } from '@careinfo/tailwind';
import { useEffect, useState } from 'react';

const TextFieldSuffix = (props: any) => {
  const {
    placeholder,
    register,
    type = 'text',
    errors,
    label,
    disabled = false,
    suffix,
    setValue,
    name,
    defaultValue = '',
  } = props;

  const [rawValue, setRawValue] = useState(defaultValue.replace(suffix, ''));

  useEffect(() => {
    if (setValue && name) {
      setValue(name, `${rawValue}${suffix}`);
    }
  }, [rawValue, suffix, name, setValue]);

  return (
    <div className={tw`w-full text-left`}>
      {label && (
        <label className={tw`block font-medium text-sm mb-1`}>{label}</label>
      )}

      <div
        className={tw`flex rounded border border-gray-300 bg-[#EEF5F4] overflow-hidden`}
      >
        <input
          placeholder={placeholder}
          disabled={disabled}
          autoComplete='off'
          value={rawValue}
          onChange={(e) => setRawValue(e.target.value)}
          type={type}
          className={tw`w-full p-2 bg-transparent focus:outline-none`}
        />
        {suffix && (
          <div
            className={tw`flex items-center px-3 bg-gray-200 text-gray-600 text-sm whitespace-nowrap`}
          >
            {suffix}
          </div>
        )}
      </div>

      <input type='hidden' {...register(name)} value={`${rawValue}${suffix}`} />

      {errors && (
        <p className={tw`text-red-500 text-xs mt-1`}>{errors?.message}</p>
      )}
    </div>
  );
};

export default TextFieldSuffix;
